module.exports = __webpack_public_path__ + "img/roulette-clubs.08d95cd1.svg";